import React, { memo, useCallback } from "react";
import { StarIcon, StarOutlineIcon } from "modules/icons";
import CircularIconButton from "./circular-icon-button";
import SyncoTooltip from "../synco-tooltip";
import colors from "app/colors";
import { useAuth } from "modules/providers/auth-provider";
import useToggleStarredIdList from "modules/hooks/use-toggle-starred-id-list";

interface IProps {
  userOrGroupId: string;
}

const UserDistributionGroupToggleStarButton = ({ userOrGroupId }: IProps) => {
  const { me } = useAuth();

  const isStarred = (me?.starredIdList ?? []).includes(userOrGroupId);

  const toggleStarredIdList = useToggleStarredIdList();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      toggleStarredIdList(userOrGroupId);
    },
    [toggleStarredIdList, userOrGroupId],
  );

  return (
    <SyncoTooltip placement="top" label={isStarred ? "Unstar" : "Star"}>
      <CircularIconButton
        size="xs"
        aria-label="Starred"
        icon={
          isStarred ? (
            <StarIcon boxSize={5} fill={colors.yellowDark} />
          ) : (
            <StarOutlineIcon
              boxSize={5}
              stroke={colors.gray40}
              fill={colors.transparent}
            />
          )
        }
        onClick={onClick}
      />
    </SyncoTooltip>
  );
};

export default memo(UserDistributionGroupToggleStarButton);
